export enum NewsletterStatues {
  ACTIVE = 'ACTIVE',
  NOT_EXIST = 'NOT_EXIST',
  PENDING = 'PENDING'
}
